export default __webpack_public_path__ + "static/media/invite.23c1df3c.png";